import React from 'react';
import Form from 'react-bootstrap/Form';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import MASpinner from '../../common/MASpinner';
import { renderCheckbox, renderField } from '../../../lib/helper/form';
import { patientNoteAdd } from '../../../lib/redux/actions/patientNotes';

const mapStateToProps = (state) => ({
  isAddingPatientNote: state.patientNotes.isAddingPatientNote,
});

const mapDispatchToProps = {
  patientNoteAdd,
};

/**
 * MED-922 - write a note about a person.
 *
 * Mounted on both the patient screen and the invoice screen. From the invoice screen it still
 * writes a PatientNote against the invoice's patient - never an InvoiceNote. The two forms sit
 * side by side there, and this one says what it is for so nobody writes "chased, no answer" about
 * the family.
 *
 * Mount it with a `form` prop naming the patient - `form={\`CreatePatientNoteForm_${id}\`}` - so a
 * draft cannot survive a navigation from one patient to the next. The default below is only a
 * fallback.
 */
class CreatePatientNoteForm extends React.Component {
  onSubmit(values) {
    const { patientNoteAdd, patientId, reset } = this.props;

    return patientNoteAdd(patientId, values.note, values.isPopup).then(() => reset());
  }

  render() {
    const { handleSubmit, error, pristine, submitting, isAddingPatientNote, compact = false } = this.props;

    return (
      <div className={compact ? '' : 'crud__section mb-3 bg-white'}>
        {!compact && (
          <>
            <div className="crud__section-icon">
              <i className="fas fa-edit" />
            </div>
            <h2 className="crud__section-header">Add a Patient Note</h2>
          </>
        )}
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <Field name="note" label="Note about this patient" id="patientNote" rows="3" type="textarea" component={renderField} />
          <Field
            name="isPopup"
            id="patientNoteIsPopup"
            label="Pop this note up whenever an invoice for this patient is opened"
            type="switch"
            component={renderCheckbox}
            wrapperClassNames="mb-3"
          />

          {isAddingPatientNote ? (
            <MASpinner />
          ) : (
            <button type="submit" disabled={pristine || submitting} className="btn btn-primary btn-block">
              Save Patient Note
            </button>
          )}
        </Form>
      </div>
    );
  }
}

CreatePatientNoteForm.propTypes = {
  patientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  compact: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'CreatePatientNoteForm',
  })(CreatePatientNoteForm),
);
